export type IdentificationType = {
  checkinId: string
  name: string
  imageKey: string
  isDriversLicense: boolean | number
}

export type IsIdentificationByCheckinIdType = {
  hotelId: string
  id: string
  identificationId: string
}

export const JapaneseIdentityDocumentType = {
  DriversLicense: 'license',
  MyNumberCard: 'mynumber',
  ResidenceCard: 'residence',
} as const
export type JapaneseIdentityDocumentType = (typeof JapaneseIdentityDocumentType)[keyof typeof JapaneseIdentityDocumentType]
